import React from 'react';
import './Footer.css';


const Footer = () => {
  return (
    <footer className="slim-footer">
      <div className="container">
        <div className="footer-flex-row">

          {/* About Section - Now more concise */}
          <div className="footer-col about">
            <h5>About ETEA</h5>
            <p>Ensuring transparency and merit in Khyber Pakhtunkhwa's testing system.</p>
          </div>

          {/* Contact Section - Icons and text on one line */}
          <div className="footer-col contact">
            <h5>Contact Info</h5>
            <div className="inline-contact">
              <i className="fa fa-phone" />
              <a href="tel:+92919219131">091-9219131</a>
              <span className="divider">|</span>
              <i className="fa fa-envelope" />
              <a href="mailto:info@etea.edu.pk">info@etea.edu.pk</a>
            </div>
          </div>

          {/* Address Section - Single line layout */}
          <div className="footer-col address">
            <h5>Location</h5>
            <p><i className="fa fa-map-marker" /> Plot 22, St 13, Sector E-8, Phase-7, Hayatabad</p>
          </div>

        </div>

        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} ETEA. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;